import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

export const dictionary = {
  'card_scene_preview.card_alt_text': {
    'en-GB': ({
      variant,
      percentageScale,
    }: {
      variant: string
      percentageScale: string
    }) => `${variant} card approximately ${percentageScale} the size of A4.`,
    'nl-NL': ({
      variant,
      percentageScale,
    }: {
      variant: string
      percentageScale: string
    }) =>
      `${variant} dat je hebt gekozen, is ongeveer ${percentageScale} van een A4-formaat.`,
  },
  'card_scene_preview.standard_size': {
    'nl-NL': 'Standaard',
    'en-GB': 'Standard',
  },
  'card_scene_preview.image_alt_text': {
    'en-GB': 'Living room background with grey sofa and wooden coffee table.',
    'nl-NL':
      'Woonkamerachtergrond met een grijze bank en een houten salontafel.',
  },
}

export const useLocaleText = createLocaleTextHook({
  dictionary,
})
